import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import BackButton from '../../../components/BackButton/BackButton';
import {getPreferenceCenterType} from '../../../consts/tnc/tncTypes';
import {makeSelectAcceptedTncByType, makeSelectTncByType} from '../../../state/selectors/consumer';
import elementsTesIds from '../../../test/consts/elementsTesIds';
import PreferenceCenter from './PreferenceCenter';

const PreferenceCenterControl = (props) => {
    const tncType = getPreferenceCenterType();
    const dataCollectionTnc = useSelector(makeSelectTncByType(tncType));
    const acceptedTermsOfUse = useSelector(makeSelectAcceptedTncByType(tncType));
    const {onApproved, backButtonClick, backButtonAriaLabel} = props;
    const {titleDescription: newTitleDescription, legals = []} = dataCollectionTnc || {};
    const {titleDescription: acceptedTitleDescription} = acceptedTermsOfUse || {};
    const titleDescription = dataCollectionTnc ? newTitleDescription : acceptedTitleDescription;
    const acceptedLegals = acceptedTermsOfUse?.legals;
    const acceptedLegalsFiltered = useMemo(() => {
        const result = acceptedLegals
            ? acceptedLegals.filter((al) => !legals.some((l) => l.code.toLowerCase() === al.code.toLowerCase()))
            : [];

        return result;
    }, [acceptedLegals]);

    return (
        <div className={'w-full'} data-testid={elementsTesIds.PREFERENCE_CENTER_PAGE}>
            <BackButton
                ariaLabel={backButtonAriaLabel}
                onClick={backButtonClick}
                testId={elementsTesIds.PREF_CENTER_BTN_BACK}
            />
            <PreferenceCenter
                legals={legals}
                acceptedLegals={acceptedLegalsFiltered}
                onApproved={onApproved}
                description={titleDescription}
            />
        </div>
    );
};

export default PreferenceCenterControl;
